import { getMediaImage } from "../../../utils/images";
import styles from "./styles.module.scss";
import { MediaSize } from "../../../types/MediaImage";
import { Webstories } from "../../../types/HomeTypes";
import { useState } from "react";
import Image from "next/image";
import { AMPStoriesPlayer } from "./Player";

export interface ComponentPrivateTypes {
  items: Webstories[];
}

function moveItemToFront(arr, index) {
  const item = arr.splice(index, 1)[0];
  arr.unshift(item);

  return arr;
}

export const WebStories = ({ items }: ComponentPrivateTypes) => {
  const [showPlayer, setShowPlayer] = useState({
    show: false,
    index: 0,
  });

  return (
    <>
      <div className={styles.containerStories}>
        {items?.map((item, index) => {
          return (
            <button
              key={item.databaseId}
              className={styles.stories}
              aria-label={`Abrir o storie: ${item.title}`}
              onClick={() =>
                setShowPlayer({
                  show: true,
                  index,
                })
              }
            >
              <div className={styles.imageWrapper}>
                <Image
                  className={styles.image}
                  src={getMediaImage(item.featuredImage, MediaSize.THUMBNAIL)}
                  alt={item.title}
                  layout="fill"
                  objectFit="cover"
                />
              </div>
            </button>
          );
        })}
      </div>
      {showPlayer.show && (
        <AMPStoriesPlayer
          items={moveItemToFront([...items], showPlayer.index)}
          setShowPlayer={setShowPlayer}
        />
      )}
    </>
  );
};
